import React, { useEffect, useRef } from "react"
import { Animated, Pressable, StyleSheet, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

const TutorEventsBell = ({ activeCount, hasP1, onPress, style }) => {
    const pulseAnim = useRef(new Animated.Value(0)).current

    useEffect(() => {
        if (!hasP1) {
            pulseAnim.stopAnimation()
            pulseAnim.setValue(0)
            return undefined
        }
        const loop = Animated.loop(
            Animated.sequence([
                Animated.timing(pulseAnim, {
                    toValue: 1,
                    duration: 1100,
                    useNativeDriver: false,
                }),
                Animated.timing(pulseAnim, {
                    toValue: 0,
                    duration: 1100,
                    useNativeDriver: false,
                }),
            ]),
        )
        loop.start()
        return () => loop.stop()
    }, [hasP1, pulseAnim])

    const bellBg = pulseAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [
            "rgba(255,255,255,0.92)",
            hasP1 ? theme.colors.accent : "rgba(255,255,255,0.92)",
        ],
    })

    return (
        <Pressable onPress={onPress} style={[styles.bellWrap, style]}>
            <Animated.View
                style={[
                    styles.bell,
                    {
                        backgroundColor: bellBg,
                        shadowColor: theme.colors.accent,
                        shadowOpacity: hasP1 ? 0.65 : 0,
                        shadowOffset: { width: 0, height: 0 },
                        shadowRadius: hasP1 ? 14 : 0,
                        elevation: hasP1 ? 6 : 1,
                        borderColor: theme.colors.lightMore,
                        borderWidth: 1,
                    },
                ]}
            >
                <FontAwesome5
                    name="bell"
                    solid
                    size={20}
                    color={
                        hasP1 ? theme.colors.primaryDark : theme.colors.primary
                    }
                />
            </Animated.View>
            {activeCount > 0 && (
                <View style={styles.bellBadge}>
                    <TextM
                        color={theme.colors.white}
                        fontSize={10}
                        fontWeight="ExtraBold"
                    >
                        {activeCount}
                    </TextM>
                </View>
            )}
        </Pressable>
    )
}

const styles = StyleSheet.create({
    bellWrap: {
        position: "relative",
        width: 44,
        height: 44,
    },
    bell: {
        width: 44,
        height: 44,
        borderRadius: 100,
        alignItems: "center",
        justifyContent: "center",
    },
    bellBadge: {
        position: "absolute",
        top: -4,
        right: -4,
        backgroundColor: theme.colors.error,
        minWidth: 18,
        height: 18,
        borderRadius: 100,
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 4,
        borderWidth: 2,
        borderColor: theme.colors.white,
    },
})

export default TutorEventsBell
